import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AlarmLog } from '../../../class/Alarm';
import { AlarmEditService } from '../../../services/alarm-edit.service';
import { AlarmsListService } from '../../../services/alarms-list.service';
import { DevicesManagerService } from '../../../services/devices-manager.service';
import { ShowIfTruncatedDirective } from '../../../utils/directives/show-if-truncated.directive';
import DynamicDatePipe from '../../../utils/pipes/dynamic-date.pipe';
import { ALARM } from '../../management-tab/alarms-sub-tab/alarms-routing.constants';
import { AlertComponent } from '../../shared/card/alert/alert.component';
import { NotificationCardComponent } from '../notification-card/notification-card.component';
import { ALARMS_NOTIFICATIONS } from '../notifications.constant';

@Component({
  selector: 'notifications-popup',

  imports: [
    MatButtonModule,
    MatIcon,
    MatTooltip,
    MatMenuModule,
    TranslatePipe,
    NotificationCardComponent,
    AlertComponent,
    MatDividerModule,
    ShowIfTruncatedDirective,
    DynamicDatePipe,
  ],
  templateUrl: './notifications-popup.component.html',
  styleUrl: './notifications-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class NotificationsPopupComponent {
  private _alarmsListService = inject(AlarmsListService);
  private _devicesManagerService = inject(DevicesManagerService);
  public notifications = computed<(AlarmLog & { deviceRegistration?: string })[]>(() =>
    this._alarmsListService
      .$unacknowledgedAlarm()
      ?.toSpliced(3)
      .map(item => ({
        ...item,
        deviceRegistration: this._devicesManagerService.get(item.uid_device)?.registration,
      }))
  );

  private _alarmEditService = inject(AlarmEditService);
  private _router = inject(Router);

  navigateToLogDetail(alarmUid: number) {
    this._router.navigate([ALARM(alarmUid)]);
  }

  public acquitLog(logUid: number) {
    this._alarmEditService.acquitLog(logUid, []);

    this._alarmsListService.$unacknowledgedAlarm?.set(
      this._alarmsListService.$unacknowledgedAlarm().filter(log => log.uid !== logUid)
    );
  }

  public seeAllLogs() {
    this._router.navigate([ALARMS_NOTIFICATIONS]);
  }
}
